var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33366 14.5003C5.25413 14.5003 6.00033 13.7541 6.00033 12.8337C6.00033 11.9132 5.25413 11.167 4.33366 11.167C3.41318 11.167 2.66699 11.9132 2.66699 12.8337C2.66699 13.7541 3.41318 14.5003 4.33366 14.5003Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.5003C12.5871 14.5003 13.3333 13.7541 13.3333 12.8337C13.3333 11.9132 12.5871 11.167 11.6667 11.167C10.7462 11.167 10 11.9132 10 12.8337C10 13.7541 10.7462 14.5003 11.6667 14.5003Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53301 2.5H3.46634C2.7196 2.5 2.34624 2.5 2.06102 2.64532C1.81014 2.77316 1.60616 2.97713 1.47833 3.22801C1.33301 3.51323 1.33301 3.8866 1.33301 4.63333V9.03333C1.33301 9.78007 1.33301 10.1534 1.47833 10.4387C1.60616 10.6895 1.81014 10.8935 2.06102 11.0213C2.34624 11.1667 2.7196 11.1667 3.46634 11.1667H10.6663V4.63333C10.6663 3.8866 10.6663 3.51323 10.521 3.22801C10.3932 2.97713 10.1892 2.77316 9.93833 2.64532C9.65311 2.5 9.27975 2.5 8.53301 2.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.83301H12.2252C12.3882 5.83301 12.4698 5.83301 12.5465 5.85143C12.6145 5.86776 12.6795 5.8947 12.7392 5.93125C12.8065 5.97248 12.8641 6.03013 12.9794 6.14543L14.3546 7.52059C14.4699 7.63589 14.5275 7.69354 14.5688 7.76082C14.6053 7.82047 14.6322 7.8855 14.6486 7.95352C14.667 8.03025 14.667 8.11178 14.667 8.27484V10.0997C14.667 10.473 14.667 10.6597 14.5943 10.8023C14.5304 10.9278 14.4284 11.0298 14.303 11.0937C14.1604 11.1663 13.9737 11.1663 13.6003 11.1663H10.667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c2129bde194c9b76d662d6a6eff1df00.svg";
export { ForwardRef as ReactComponent };